import { ApiData, ApiDescription, RequestsMethod } from '@shared/clientTypes';
import { TimelineEventDTO } from './studentInsights.apis';

export type UserJourneyHubspotStatus = 'found' | 'not_found' | 'unavailable' | 'disabled';

export type UserJourneyHubspotDTO = {
  status: UserJourneyHubspotStatus;
  contactId?: string;
  url?: string;
  createdAt?: string;
  lifecycleStage?: string;
  leadStatus?: string;
  owner?: string;
  counts?: Partial<Record<'deals' | 'tickets' | 'calls' | 'emails' | 'notes' | 'meetings', number>>;
  reason?: string;
};

export type UserJourneyUserDTO = {
  _id: string;
  fullName: string;
  email: string;
  roles: number[];
  avatar?: string;
  phoneNumber?: string;
  parentEmail?: string;
  graduationYear?: number;
  mentorStatus?: string;
  isTestUser?: boolean;
  isDeactivated?: boolean;
  deactivationReason?: string;
  createdAt?: string;
  lastLogin?: string;
};

export type UserJourneyDTO = {
  user: UserJourneyUserDTO;
  events: TimelineEventDTO[];
  hubspot: UserJourneyHubspotDTO;
  generatedAt: string;
};

export const getUserJourney: ApiDescription = {
  endpoint: '/admin/users/:id/journey',
  method: RequestsMethod.Get,
};

export type GetUserJourney = ApiData<never, UserJourneyDTO>;
